import { useInfoBlocksForLocationCategory } from "../../../hooks/useInfoBlocksForLocationCategory.js";
import { InfoBlockCard } from "../../InfoBlockCard.js";
import "react";
import { Loading } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
//#region src/modules/Locations/shared/LocationInfo/components/LocationInfoBlocksList.tsx
function LocationInfoBlocksList({ infoBlockCategoryId, locationId }) {
	const { data, loading } = useInfoBlocksForLocationCategory({
		infoBlockCategoryId,
		locationId
	});
	if (!data && loading) return /* @__PURE__ */ jsx(Loading, { overlay: true });
	return /* @__PURE__ */ jsx("div", {
		className: "gap-y-sm flex flex-col",
		children: data?.infoBlocks.map((infoBlock) => /* @__PURE__ */ jsx(InfoBlockCard, { infoBlock }, infoBlock.id))
	});
}
//#endregion
export { LocationInfoBlocksList };

//# sourceMappingURL=LocationInfoBlocksList.js.map